<template>
    <ListenerGenreLibrary v-if="isListenerMobile" />
    <GenreLibrary v-else />
</template>

<script>
import GenreLibrary from './GenreLibrary.vue'
import ListenerGenreLibrary from './ListenerGenreLibrary.vue'

export default {
    name: 'genres',
    components: {
        GenreLibrary,
        ListenerGenreLibrary
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
